module.exports = __webpack_public_path__ + "img/KSC01834.f77dae0a.jpg";